import * as React from "react";
import BasketSvg from "./icons/basket.svg";
import ShoppingBagSvg from "./icons/shopping-bag-2.svg";
import CartSvg from "./icons/cart.svg";
import CloseSvg from "./icons/close.svg";
import MinusSvg from "./icons/minus.svg";
import PlusSvg from "./icons/plus.svg";
import RemoveSvg from "./icons/remove.svg";
import TrashSvg from "./icons/trash.svg";
import ArrowLeftSvg from "./icons/arrow-left.svg";
import AddressSvg from "./icons/address.svg";
import MenuSvg from "./icons/menu.svg";
import FoodSvg from "./icons/food.svg";
import QuestionMarkSvg from "./icons/question-mark.svg";
import PhoneSvg from "./icons/phone.svg";


interface IconProps {
    width?: number;
    className?: string;
    onClick?: () => void;
}
export const IconFood = (props: IconProps) => {
    return (<img {...props} src={FoodSvg} alt={FoodSvg} />)
}
export const IconMenu = (props: IconProps) => {
    return (<img {...props} src={MenuSvg} alt={MenuSvg} />)
}
export const IconBasket = (props: IconProps) => {
    return (<img {...props} src={BasketSvg} alt={BasketSvg} />)
}
export const IconShoppingBag = (props: IconProps) => {
    return (<img {...props} src={ShoppingBagSvg} alt={ShoppingBagSvg} />)
}
export const IconCart = (props: IconProps) => {
    return (<img {...props} src={CartSvg} alt={CartSvg} />)
}
export const IconMinus = (props: IconProps) => {
    return (<img {...props} src={MinusSvg} alt={MinusSvg} />)
}
export const IconClose = (props: IconProps) => {
    return (<img {...props} src={CloseSvg} alt={CloseSvg} />)
}
export const IconPlus = (props: IconProps) => {
    return (<img {...props} src={PlusSvg} alt={PlusSvg} />)
}
export const IconRemove = (props: IconProps) => {
    return (<img {...props} src={RemoveSvg} alt={RemoveSvg} />)
}
export const IconTrash = (props: IconProps) => {
    return (<img {...props} src={TrashSvg} alt={TrashSvg} />)
}
export const IconArrowLeft = (props: IconProps) => {
    return (<img {...props} src={ArrowLeftSvg} alt={ArrowLeftSvg} />)
}
export const IconAddress = (props: IconProps) => {
    return (<img {...props} src={AddressSvg} alt={AddressSvg} />)
}
export const IconQuestionMark = (props: IconProps) => {
    return (<img {...props} src={QuestionMarkSvg} alt={QuestionMarkSvg} />)
}
export const IconPhone = (props: IconProps) => {
    return (<img {...props} src={PhoneSvg} alt={PhoneSvg} />)
}